import {
  post
} from './request.js'

// login.vue
export const identifyCode = data => post('admin/get_verify', data);
export const login = data => post('account/sign-in', data);
export const getMenuDate = data => post('admin/admin/get_auth_menu', data);
export const signOut = data => post('account/sign-out', data);
export const uploadfile = data => post('imports/upload/img', data, 'file');
// 注册 reg
export const registerAccount = data => post('account/register', data);
export const forgetPwdReset = data => post('account/forget-pwd-reset', data);

// public
export const getProvinceList = data => post('address/province/list', data);
export const getCityList = data => post('address/city/list', data);
export const getAreaList = data => post('address/county/list', data);
// 官网
export const getProductList = data => post('home/package/sale-list', data);
export const getProductInfo = data => post('home/package/sale-info', data);
export const getPaymentInfo = data => post('home/get/settings/info', data);
export const getSystemPaySettingInfo = data => post('system/get/app/payment/settings/info', data);
export const getPaymentChannelList = data => post('purchase/get-payment-channel-list', data);
export const payOrder = data => post('purchase/pay-order', data);
export const affirmOrder = data => post('purchase/affirm-order', data);
export const getRegisterInfo = data => post('system/get/platform/register/settings/info', data);
export const getPackageFree = data => post('package/free', data);
// 企业基础信息 basic_info
export const getBasicInfo = data => post('company/basic/info/list', data);
export const setBasicInfo = data => post('company/basic/info/set', data);
// 企业认证 attestation
export const getCompanyInfo = data => post('company/certificate/info', data);
export const setCompanyInfo = data => post('company/certificate/create', data);
// 发票管理 invoice_management
export const getInvoiceList = data => post('invoice/list', data);
export const applyForInvoice = data => post('invoice/create', data);
export const getInvoiceInfo = data => post('invoice/info', data);
// 当前服务 current_service
export const getCompanyServiceInfo = data => post('company/service/info', data);
export const getCompanyServiceList = data => post('company/service/list', data);
export const getUserNumber = data => post('api.v1.merchant/fleet/user/info', data, '8394');
// 抬头管理 header_management
export const getHeadingList = data => post('invoice/heading/list', data);
export const addHeading = data => post('invoice/heading/create', data);
export const editHeading = data => post('invoice/heading/update', data);
export const getHeadingInfo = data => post('invoice/heading/info', data);
export const delHeading = data => post('invoice/heading/delete', data);
export const setDefaultHeading = data => post('invoice/heading/set/default', data);
// 邮寄地址 address_management
export const getMailList = data => post('company/mail/list', data);
export const addMail = data => post('company/mail/create', data);
export const editMail = data => post('company/mail/update', data);
export const getMailInfo = data => post('company/mail/info', data);
export const delMail = data => post('company/mail/delete', data);
// 购买记录 purchase_record
export const getPurchaseRecordList = data => post('consume/order/purchase/history/list', data);
export const getPurchaseRecordInfo = data => post('consume/order/info', data);
// 账号信息 personal_info
export const getAccountInfo = data => post('account/info', data);
export const verifyCodeSend= data => post('verifyCode/send', data);
export const changePassword= data => post('account/edit-password', data);
export const changeBaseData= data => post('account/edit-base-data', data, '');
export const changeBinding= data => post('account/personal-modify-binding', data);
// 账号权限 account_management
export const getAccountPermissionList = data => post('account/get-account-permission-list', data);
export const getAccountList = data => post('account/get-transferor-list', data);
export const addgetAccount = data => post('account/uam-add-admin-info', data);
export const editAccount = data => post('account/uam-edit-admin-info', data);
export const delAccount = data => post('account/uam-del-admin', data);
export const confirmationAccount = data => post('account/uam-confirmation-transferor', data);
// 系统首页 welcome